import {RemoveButton} from '@wallaby-ui/core';
import classNames from 'classnames';
import {isEmpty, pick} from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';
import {defineMessages} from 'react-intl';

import styles from './ArrayItem.less';
import ComplexComponent from './ComplexComponent';
import {ContentComponent} from 'src/js/model/auto_layout_content_schema';
import {LayoutComponent} from 'src/js/model/auto_layout_layout_schema';
import {MetadataSchema} from 'src/js/model/auto_layout_metadata_schema';

const I18N = defineMessages({
  REMOVE_BUTTON: {
    id: 'autoLayout.array.button.remove',
    defaultMessage: 'Remove array item',
    description: 'text for auto layout array remove button',
  },
});

export class ArrayItem extends React.PureComponent {
  constructor() {
    super();

    this.handleChange = this.handleChange.bind(this);
    this.remove = this.remove.bind(this);
  }

  handleChange() {
    const {onDataChange} = this.props;
    onDataChange(this.getOnDataChangeData());
  }

  getOnDataChangeData() {
    const {layout} = this.props;
    return {
      ...pick(this.props, ['pathToData', 'data']),
      label: layout.getLabel(),
    };
  }

  getOnRemoveData() {
    const {arrayItemIdx} = this.props;
    return {itemIdx: arrayItemIdx};
  }

  isReadOnly() {
    const {layout, readOnly} = this.props;
    return layout.getReadOnly() || readOnly === true;
  }

  remove() {
    const {onRemove} = this.props;
    if (!this.isReadOnly()) {
      // notify parent array about removal
      onRemove(this.getOnRemoveData());
    }
  }

  render() {
    const {
      arrayItemIdx,
      autoLayoutStateId,
      content,
      data,
      dataChanges,
      dataSets,
      expanded,
      idSuffix,
      isLast,
      layout,
      metadata,
      pathToData,
      rootData,
      screenId,
      textOnly,
      onDataChange,
    } = this.props;
    const isReadOnly = this.isReadOnly();
    const newIdSuffix = `${
      isEmpty(idSuffix) ? '' : '.'
    }${idSuffix}.${arrayItemIdx}`;
    return (
      <div className={styles.dlArrayItem}>
        <div
          className={styles.dlArrayItemContent}
          data-dl-array-item-index={arrayItemIdx}
        >
          <ComplexComponent
            autoLayoutStateId={autoLayoutStateId}
            content={content}
            dataChanges={dataChanges}
            dataSets={dataSets}
            layout={layout}
            metadata={metadata}
            screenId={screenId}
            idSuffix={newIdSuffix}
            isLast={isLast}
            rootData={rootData}
            onDataChange={onDataChange}
            data={data}
            pathToData={pathToData}
            expanded={expanded}
            readOnly={isReadOnly}
            textOnly={textOnly}
          />
        </div>
        {isReadOnly ? null : (
          <RemoveButton
            removeCallback={this.remove}
            className={classNames(styles.dlArrayItemRemoveButton, 'float-end')}
            iconClass={'far fa-trash-alt'}
            item={data}
            disabled={isReadOnly}
            titleText={I18N.REMOVE_BUTTON.id}
          />
        )}
      </div>
    );
  }
}

ArrayItem.displayName = 'ArrayItem';

ArrayItem.propTypes = {
  autoLayoutStateId: PropTypes.string.isRequired,
  content: PropTypes.instanceOf(ContentComponent).isRequired,
  dataChanges: PropTypes.objectOf(PropTypes.any),
  layout: PropTypes.instanceOf(LayoutComponent).isRequired,
  rootData: PropTypes.objectOf(PropTypes.any).isRequired,
  metadata: PropTypes.instanceOf(MetadataSchema).isRequired,
  screenId: PropTypes.string.isRequired,
  idSuffix: PropTypes.string,
  isLast: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
  pathToData: PropTypes.string,
  readOnly: PropTypes.bool,
  textOnly: PropTypes.bool,
  expanded: PropTypes.bool,
  onDataChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  arrayItemIdx: PropTypes.number.isRequired,
};

ArrayItem.defaultProps = {
  data: {},
  dataChanges: undefined,
  idSuffix: '',
  pathToData: '',
  readOnly: false,
  textOnly: false,
  expanded: false,
};

export default ArrayItem;
